import React from 'react';
import { useNavigate } from 'react-router-dom';

import './Home.css';


import FeatureSection from '../components/FeatureSection';

function Home() {
  const navigate = useNavigate();

  return (
    <div className='home_container'>

      {/* Hero Section */}
      <div className='sub_container hero_section'>
        <div className="logo-text-row">
          {/* <img src={logo1} alt="Technologies" /> */}
          <h3 className="gradient-text">
            Driven by ideas and built to scale, we craft intelligent solutions that lead today and shape tomorrow.
          </h3>
        </div>

        <p className="hero-text">
          Empowering businesses through cutting-edge technology. From custom software to end-to-end digital transformation, we deliver excellence that accelerates growth and unlocks new possibilities. Smart solutions. Seamless evolution. Innovation that moves with you. Let’s create what’s next.
        </p>

        <div className="hero-buttons">
          <button className='btn' onClick={() => navigate('/services')}>Explore Services →</button>
          <button className='btn1' onClick={() => navigate('/contact')}>Get in Touch</button>
        </div>
      </div>

     

      {/* Cards Section */}
      <div className='sub_container cards-container'>
        <FeatureSection />
      </div>

{/* Why Choose Us Section */}
<div className='sub_container whychooseus fancy-anim'>
  <h2 className="why-title">Why Choose Us</h2>
  <h2 className="why-titleedge">“The Hiten Edge”</h2>
  <p className="why-subtitle">
    We don’t just build software — we build partnerships. <br />
    Our clients stay with us because we deliver clarity, collaboration, and commitment with every project. <br />
    We believe great technology is not about code — it’s about connection.
  </p>

  <div className="why-card feature">
    <h3 className="why-heading">“Built Different. Built for You.”</h3>
    <ul className="why-list">
      <li>We ask <strong>why</strong> before we code <strong>what</strong> — understanding the problem is the key to delivering real value.</li>
      <li>We see the bigger picture — not just features, but meaningful solutions that drive business growth.</li>
      <li>We grow with you — not away from you; your success is our mission.</li>
      <li>We innovate fearlessly, combining creativity and technology to stay ahead of the curve.</li>
      <li>We ensure clarity, transparency, and collaboration at every step of the journey.</li>
      <li>We turn complex challenges into elegant, scalable solutions that evolve with your business.</li>
    </ul>
  </div>
</div>




      {/* Stats Section */}
      <div className='sub_container projinfo'>
        <article className="feature">
          <h1 className="number">150+</h1>
          <p className="text">Projects Delivered</p>
        </article>
        <article className="feature">
          <h1 className="number">30+</h1>
          <p className="text">Happy Clients</p>
        </article>
        <article className="feature">
          <h1 className="number">5+</h1>
          <p className="text">Years Experience</p>
        </article>
      </div>

 
    </div>

    
  );
}

export default Home;
